/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CompanyDocumentType {
  LetterOfAuthorization = "letter_of_authorization",
  Datafile = "datafile",
  PricingAgreement = "pricing_agreement",
  Other = "other",
  CustomerSpecificPricingReport = "customer_specific_pricing_report",
  RateSheet = "rate_sheet",
  AddressBook = "address_book",
  SavedCommodities = "saved_commodities",
}

export function instanceOfCompanyDocumentType(value: any): boolean {
  for (const key in CompanyDocumentType) {
    if (Object.prototype.hasOwnProperty.call(CompanyDocumentType, key)) {
      if (
        CompanyDocumentType[key as keyof typeof CompanyDocumentType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CompanyDocumentTypeFromJSON(json: any): CompanyDocumentType {
  return CompanyDocumentTypeFromJSONTyped(json, false);
}

export function CompanyDocumentTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyDocumentType {
  return json as CompanyDocumentType;
}

export function CompanyDocumentTypeToJSON(
  value?: CompanyDocumentType | null,
): any {
  return value as any;
}

export function CompanyDocumentTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CompanyDocumentType {
  return value as CompanyDocumentType;
}
